import type { DocumentImageUpload } from "./editor-images";
import { lazy, Suspense } from "react";
import { ContentLoading } from "../components/ContentLoading";
import { loadDocumentEditor } from "./preload-editor";

const EditorContent = lazy(() =>
  loadDocumentEditor().then((module) => ({ default: module.DocumentEditor })),
);
export function DocumentEditor(props: {
  markdown: string;
  onChange: (markdown: string) => void;
  onSave?: () => void;
  pageId?: string;
  uploadImage?: DocumentImageUpload;
}) {
  return (
    <Suspense
      fallback={
        <ContentLoading label="Loading editor…" variant="document" className="min-h-72 py-6" />
      }
    >
      <EditorContent {...props} />
    </Suspense>
  );
}
